export const MESSAGE_STATES = {
  PENDING: { text: "Pendente", color: "warning" },
  SENT: { text: "Enviada", color: "info" },
  DELIVERED: { text: "Entregue", color: "success" },
  FAILED: { text: "Falhou", color: "error" },
  FALLBACK_TRIGGERED: { text: "Fallback", color: "orange" },
  COMPLETED: { text: "Concluída", color: "success" },
  ABORTED: { text: "Abortada", color: "grey" },
};

export const MESSAGE_CHANNELS = {
  WHATSAPP: { text: "WhatsApp", color: "green" },
  EMAIL: { text: "E-mail", color: "blue" },
  SMS: { text: "SMS", color: "purple" },
  WEBHOOK: { text: "Webhook", color: "grey" },
};

export const MESSAGE_STATE_OPTIONS = Object.entries(MESSAGE_STATES).map(
  ([value, meta]) => ({ value, text: meta.text })
);

export function formatRecipient(recipient, channel) {
  if (!recipient || typeof recipient !== "object") return "—";
  const r = recipient;
  if (r.phone) return r.phone;
  if (r.to) return r.to;
  if (r.number) return r.number;
  if (r.email) return r.email;
  if (channel === "EMAIL" && r.address) return r.address;
  try {
    return JSON.stringify(r);
  } catch {
    return "—";
  }
}

export default {
  MESSAGE_STATES,
  MESSAGE_CHANNELS,
  MESSAGE_STATE_OPTIONS,
  formatRecipient,
};
